import React, { useState } from "react";
import { createVenueReviewApi } from "../../../api/api";
import { RatingInput } from "./RatingStars";
import { REVIEW_COMMENT_MAX } from "./reviewsModel";
import "./reviews.css";

/**
 * "Dejar reseña" modal of Mis reservas: 1-5 stars (required) + optional comment.
 * `onSubmitted(rating)` runs after the API accepted the review.
 */
const ReviewFormModal = ({ reservation, token, onClose, onSubmitted }) => {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    if (!rating) { setError("Elegí una calificación de 1 a 5 estrellas."); return; }
    try {
      setSubmitting(true);
      setError("");
      await createVenueReviewApi({ reservationId: reservation._id, rating, comment: comment.trim() }, token);
      onSubmitted?.(rating);
    } catch (err) {
      setError(err?.response?.data?.message || "No pudimos enviar tu reseña. Intentá de nuevo.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="r-modal-back" style={{ zIndex: 9999 }} onClick={onClose}>
      <form className="r-modal" style={{ maxWidth: 440 }} role="dialog" aria-modal="true" aria-label="Dejar reseña"
        onClick={(e) => e.stopPropagation()} onSubmit={submit}>
        <div className="rv-form-body">
          <h3 className="rv-form-title">¿Cómo fue tu experiencia?</h3>
          <p className="rv-form-sub">{reservation.barName || "Tu reserva"}</p>
          <RatingInput value={rating} onChange={(n) => { setRating(n); setError(""); }} disabled={submitting} />
          <label className="rv-form-label" htmlFor="rv-comment">Comentario (opcional)</label>
          <textarea
            id="rv-comment"
            className="rv-textarea"
            value={comment}
            maxLength={REVIEW_COMMENT_MAX}
            disabled={submitting}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Contá qué te pareció"
          />
          <div className="rv-counter" aria-live="polite">{comment.length}/{REVIEW_COMMENT_MAX}</div>
          {error && <div className="rv-form-error" role="alert">{error}</div>}
          <div className="modal-foot" style={{ marginTop: 18 }}>
            <button type="button" className="r-btn-soft" style={{ flex: 1, padding: 12, borderRadius: 11 }}
              onClick={onClose} disabled={submitting}>
              Cancelar
            </button>
            <button type="submit" className="r-btn-dark" style={{ flex: 1, padding: 12, borderRadius: 11 }} disabled={submitting}>
              {submitting ? "Enviando…" : "Enviar reseña"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ReviewFormModal;
